import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/text-input-field/text-input-field.js';
      import {HTMLInputTypeAttribute, ObcTextInputFieldTextAlign, ObcTextInputFieldSize, ObcTextInputFieldPlacement} from '@oicl/openbridge-webcomponents/dist/components/text-input-field/text-input-field.js';

      export interface Props {
     value?: string;
     placeholder?: string;
     type?: HTMLInputTypeAttribute;
     textAlign?: ObcTextInputFieldTextAlign;
     disabled?: boolean;
     readonly?: boolean;
     error?: boolean;
     errorText?: string;
     rejectUpdatesOnFocus?: boolean;
     rejectUpdates?: boolean;
     rejectDuplicateUpdates?: boolean;
     name?: string;
     maxlength?: number | undefined;
     minlength?: number | undefined;
     size?: ObcTextInputFieldSize;
     hasLeadingIcon?: boolean;
     hasClearButton?: boolean;
     helperText?: string;
     label?: string;
     required?: boolean;
     hasLabelIcon?: boolean;
     labelPlacement?: ObcTextInputFieldPlacement;
     hasHelperIcon?: boolean;
     helperPlacement?: ObcTextInputFieldPlacement
   }

      
  
      export type {HTMLInputTypeAttribute, ObcTextInputFieldTextAlign, ObcTextInputFieldSize, ObcTextInputFieldPlacement} from '@oicl/openbridge-webcomponents/dist/components/text-input-field/text-input-field.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcTextInputField',
  props: {
    value: {},
    placeholder: {},
    type: {},
    textAlign: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    error: { type: Boolean },
    errorText: {},
    rejectUpdatesOnFocus: { type: Boolean },
    rejectUpdates: { type: Boolean },
    rejectDuplicateUpdates: { type: Boolean },
    name: {},
    maxlength: {},
    minlength: {},
    size: {},
    hasLeadingIcon: { type: Boolean },
    hasClearButton: { type: Boolean },
    helperText: {},
    label: {},
    required: { type: Boolean },
    hasLabelIcon: { type: Boolean },
    labelPlacement: {},
    hasHelperIcon: { type: Boolean },
    helperPlacement: {}
  },
  emits: ["input", "change", "clear", "blur"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onInput: (event: CustomEvent<unknown>) => emit('input', event as CustomEvent<unknown>),
onChange: (event: CustomEvent<unknown>) => emit('change', event as CustomEvent<unknown>),
onClear: (event: CustomEvent<unknown>) => emit('clear', event as CustomEvent<unknown>),
onBlur: (event: CustomEvent<unknown>) => emit('blur', event as CustomEvent<unknown>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-text-input-field',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})